import store from '../../store';
import axios from 'axios';
import util from '../util';
import router from '../../router';
import swal from 'sweetalert2';
import Setting from '../../setting';

// import { Message, Notice } from 'view-design';

// 创建一个错误
function errorCreate(msg) {
  const err = new Error(msg);
  errorLog(err);
  throw err;
}

// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch('admin/log/push', {
    message: '数据请求异常',
    type: 'error',
    meta: {
      error: err
    }
  });
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.error('>>>>>> Error >>>>>>');
    console.log(err);
  }

  swal.fire({
    title: tParam(err.message),
    icon: 'error',
    confirmButtonText: window.$t('Front_Btn_OK'),
    cancelButtonText: window.$t('Front_Btn_Cancel')
  });
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: Setting.apiBaseURL
  // timeout: 5000 // 请求超时时间
});

// 解析多语言带参数
const tParam = str => {
  let array = str.split('|');
  let key = array[0];
  array.shift();

  let result = window.$t(key, array);

  for (let i = 0; i < array.length; i++) {
    result = result.replace('[' + i + ']', array[i]);
  }

  return result;
};

// 请求拦截器
service.interceptors.request.use(
  config => {
    store.commit('admin/loader/start');

    // 在请求发送之前做一些处理
    const token = util.cookies.get('token');
    // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
    config.headers['Authorization'] = 'Bearer ' + token;
    return config;
  },
  error => {
    // 发送失败
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    store.commit('admin/loader/end');

    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data;

    // return dataAxios;

    // Blob对象
    if (dataAxios instanceof Blob) {
      if (dataAxios.type == 'application/json') {
        // 返回json(出现异常)
        dataAxios.text().then(text => {
          const data = JSON.parse(text);
          errorCreate(data.message);
        });
        throw new Error();
      } else {
        // 返回Blob对象
        return dataAxios;
      }
    }

    const code = dataAxios.code;

    // console.log('dataAxios', dataAxios)
    // console.log('code', code)
    // 根据 code 进行判断
    if (code == null) {
      // 如果没有 code 代表这不是项目后端开发的接口
      return dataAxios;
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (code) {
        case 0:
          // [ 示例 ] code === 0 代表没有错误
          return dataAxios.data;
        // case 401:
        //     console.log('401');
        //     router.push('/account/login');
        //     // [ 示例 ] code === 0 代表没有错误
        //     return dataAxios.data;
        // case 'xxx':
        //     // [ 示例 ] 其它和后台约定的 code
        //     errorCreate(`[ code: xxx ] ${dataAxios.msg}: ${response.config.url}`);
        //     break;
        default:
          // 不是正确的 code
          errorCreate(dataAxios.message);
      }
    }
  },
  error => {
    if (error && error.response && error.response.status === 401) {
      router.push('/login?redirect=' + router.history._startLocation);
    }

    store.commit('admin/loader/end');
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误';
          break;
        case 401:
          error.message = '未授权，请登录';
          break;
        case 403:
          error.message = '拒绝访问';
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = '请求超时';
          break;
        case 500:
          error.message = '内部错误';
          break;
        case 501:
          error.message = '服务未实现';
          break;
        case 502:
          error.message = '网关错误';
          break;
        case 503:
          error.message = '服务不可用';
          break;
        case 504:
          error.message = '网关超时';
          break;
        case 505:
          error.message = 'HTTP版本不受支持';
          break;
        default:
          break;
      }
    }
    errorLog(error);
    return Promise.reject(error);
  }
);

export default service;
